var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('div',{staticClass:"youtube",class:{ disabled: _vm.disabled }},[_c('youtube',{ref:"youtube",staticClass:"youtube__player",attrs:{"video-id":_vm.id},on:{"playing":_vm.onPlay,"paused":_vm.onPause}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }